'use client';

import Image from 'next/image';
import { useState } from 'react';

interface AvatarProps {
  src: string;
  alt: string;
  size?: number;
  className?: string;
}

export default function Avatar({ src, alt, size = 70, className = '' }: AvatarProps) {
  const [imageError, setImageError] = useState(false);

  // Générer les initiales à partir du nom
  const getInitials = (name: string) => {
    const words = name.split(' ');
    if (words.length >= 2) {
      return `${words[0][0]}${words[words.length - 1][0]}`.toUpperCase();
    }
    return name.substring(0, 2).toUpperCase();
  };

  // Générer une couleur basée sur le nom (pour la cohérence)
  const getColorFromName = (name: string) => {
    const colors = [
      'bg-blue-500',
      'bg-green-500',
      'bg-purple-500',
      'bg-pink-500',
      'bg-indigo-500',
      'bg-teal-500',
      'bg-orange-500',
      'bg-red-500',
    ];
    const index = name.charCodeAt(0) % colors.length;
    return colors[index];
  };

  if (imageError || !src) {
    return (
      <div
        className={`flex items-center justify-center rounded-full text-white font-bold ${getColorFromName(alt)} ${className}`}
        style={{ width: size, height: size, fontSize: size * 0.4 }}
      >
        {getInitials(alt)}
      </div>
    );
  }

  return (
    <Image
      src={src}
      alt={alt}
      width={size}
      height={size}
      className={`rounded-full ${className}`}
      onError={() => setImageError(true)}
      unoptimized={src.includes('randomuser.me')} // Désactiver l'optimisation pour les URLs externes
    />
  );
}
